import axios from 'axios';
import { triggerAuthFailure } from './authFailure';
import { apiOrigin } from '../utils/env';

const apiClient = axios.create({
  baseURL: apiOrigin || '',
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      triggerAuthFailure('session-expired');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
